<template>
  <div>
    <el-badge :is-dot="hasNewInfo" class="problem-badge">
      <el-button type="warning" size="small" plain @click="show">
        <span :class="{ 'new-info': hasNewInfo }">
          {{
            needKfReplyProblemCount > 0 ? `待处理问题${needKfReplyProblemCount}个` : problemCount > 0 ? `自动处理问题${problemCount}个`
              : "清闲无事"
          }}</span></el-button>
    </el-badge>
    <el-drawer :visible.sync="visible" direction="rtl" :with-header="false" custom-class="order-problem-drawer"
      :show-close="false" size="60%">
      <div class="content-wrapper">
        <el-tabs v-model="activeProblemId" type="card" @tab-click="handleTabChange">
          <el-tab-pane v-for="problem in problemList" :key="problem.id" :name="problem.id">
            <span slot="label">
              <el-badge :value="problem.hasNewInfoToRead ? '' : null" :is-dot="problem.hasNewInfoToRead"
                class="problem-badge">
                <span>{{ getProblemLabel(problem) }}</span>
              </el-badge>
            </span>

            <div class="problem-content">
              <!-- 问题基本信息 -->
              <div class="problem-actions">
                <div v-if="problem.routeId" class="problem-route-actions">
                  <el-button type="primary" size="mini" plain icon="el-icon-share"
                    @click.stop="showRoutePlan(problem.routeId)">
                    行程规划
                  </el-button>
                  <el-button v-if="problem.route" type="success" size="mini" plain icon="el-icon-video-camera"
                    @click.stop="go2MonitorPage(problem.route)">
                    监控
                  </el-button>
                </div>
                <el-button type="danger" size="mini" plain @click="handleCloseProblem(problem)">
                  关闭问题
                </el-button>
              </div>
              <div v-if="currentProblem" class="problem-info">
                <el-descriptions :column="2" border size="small">
                  <el-descriptions-item label="问题描述">
                    {{ currentProblem.problemDesc || "无" }}
                  </el-descriptions-item>
                  <el-descriptions-item label="问题状态">
                    {{ currentProblem.statusDesc || "无" }}
                  </el-descriptions-item>

                  <el-descriptions-item label="行程信息">
                    <template v-if="currentProblem.route">
                      {{ currentProblem.route.driverNo }}
                      {{ currentProblem.route.pathId | pathNameTransfer }}
                      {{ currentProblem.route.showTime }}
                    </template>
                    <template v-else>无</template>
                  </el-descriptions-item>
                  <el-descriptions-item label="创建时间">
                    {{ currentProblem.createTime | dateFormat("yyyy-MM-dd hh:mm:ss") }}
                  </el-descriptions-item>
                  <el-descriptions-item label="订单信息" :span="2" v-if="currentProblem.order">
                    <span>{{ currentProblem.order.orderIndex + 1 }} 号单 &nbsp;&nbsp; </span>
                    <span>
                      <span>{{ currentProblem.order.telephone }} &nbsp;&nbsp;</span>
                      <span v-if="currentProblem.order.appointTelephone">乘车人：{{ currentProblem.order.appointTelephone
                      }}&nbsp;&nbsp;</span>
                    </span>
                    <span>
                      <span>{{ currentProblem.order ? "上车地：" : "下车地：" }}</span>
                      <span>{{
                        currentProblem.order
                          ? currentProblem.order.departure
                          : currentProblem.order.departure
                      }}</span>
                    </span>
                    <span class="order-route-status">
                      <span v-if="currentProblem.order.abnormalFinish">超时未上车</span>
                      <span v-else>{{ currentProblem.order.routeStatus | enumTransfer(routeDetailOpts) }}</span>
                    </span>
                  </el-descriptions-item>
                </el-descriptions>
              </div>

              <!-- 对话列表 -->
              <div class="message-list" ref="messageList">
                <div v-for="(msg, index) in messageList" :key="msg.id || index" class="message-item" :class="{
                  'message-right': msg.msgRole === 'DRIVER',
                  'message-left': msg.msgRole !== 'DRIVER'
                }">
                  <div class="message-bubble" :class="{
                    'bubble-kf': msg.msgRole !== 'DRIVER',
                    'bubble-driver': msg.msgRole === 'DRIVER'
                  }">
                    <div class="message-content">
                      <span>{{ msg.content }}</span>
                      <span v-if="msg.msgRole === 'SYS'" style="color: #909399">（系统）</span>
                      <span v-if="msg.msgRole === 'DRIVER'" style="color: #409eff">（司机）</span>
                    </div>
                    <div class="message-time">
                      <span>{{ msg.createTime | dateFormat("yyyy-MM-dd hh:mm:ss") }}</span>
                    </div>

                    <!-- 图片/视频列表 -->
                    <div v-if="msg.photos && msg.photos.length > 0" class="message-photos">
                      <div v-for="(media, mediaIndex) in msg.photos" :key="mediaIndex" class="media-item">
                        <!-- 图片 -->
                        <el-image v-if="isImage(media)" :src="media" :preview-src-list="getImageList(msg.photos)"
                          fit="cover" class="message-photo"></el-image>
                        <!-- 视频/其他文件 -->
                        <file-preview v-else :value="media" class="message-media" />
                      </div>
                    </div>
                  </div>
                </div>

                <div v-if="messageList.length === 0" class="empty-message">暂无对话记录</div>
              </div>

              <div v-if="needHandle && currentHandleResult.nextAllowedComTasks">
                <!-- 客服操作面板 -->
                <KfActionPanel :handle-result="currentHandleResult" :order-problem="currentProblem"
                  @success="handleActionSuccess" />
              </div>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
    </el-drawer>
    <audio ref="submitProblemAudio" style="display: none" preload="auto">
      <source src="../../../static/video/submit_problem.wav" />
    </audio>
    <audio ref="addInfoAudio" style="display: none" preload="auto">
      <source src="../../../static/video/add_info.wav" />
    </audio>
  </div>
</template>

<script>
import { getKfNeedFocusProblemList, getOrderProblem, updateKfInfoReadStatus, closeProblem } from "@/api/problem";
import { getDriverInfo } from "@/api";
import { ORDER_PROBLEM_UPDATED, SHOW_ROUTE_PLAN } from "@/core/const/global-event";
import KfActionPanel from "./KfActionPanel.vue";
import FileUtil from "@/util/file";
import { LocalStorage } from "@/util";
import { mapState } from "vuex";
import Router from "@/route";

export default {
  name: "OrderProblemHandle",
  components: {
    KfActionPanel
  },

  beforeDestroy() {
    this.stopRefreshTimer();
  },

  events: {
    [ORDER_PROBLEM_UPDATED](data) {
      this.handleOrderProblemUpdated(data);
    }
  },

  watch: {},

  computed: {
    ...mapState({
      routeDetailOpts: (state) => state.enumMap["ROUTE_DETAIL_STATUS"]
    }),

    hasNewInfo() {
      // 是否有存在 有 needKfReply 的问题
      return this.problemList.some((problem) => problem.hasNewInfoToRead);
    },

    needKfReplyProblemCount() {
      return this.problemList.filter((problem) => problem.needKfReply).length;
    },

    problemCount() {
      return this.problemList.length;
    },

    messageList() {
      const list = this.currentProblem && this.currentProblem.handleMsgList;
      return Array.isArray(list) ? list : [];
    },

    currentHandleResult() {
      return (this.currentProblem && this.currentProblem.currentHandleResult) || {};
    },

    needHandle() {
      return this.currentHandleResult && this.currentHandleResult.dealRole === "KF";
    }
  },

  mounted() {
    // 启动定时刷新，每10秒刷新一次
    // this.startRefreshTimer();

    this.loadProblemList();
  },

  data() {
    return {
      visible: false,
      problemList: [],
      activeProblemId: "",
      currentProblem: null,
      refreshTimer: null
    };
  },

  methods: {
    show() {
      this.visible = true;
      this.loadProblemList();
    },

    close() {
      this.visible = false;
    },

    handleOrderProblemUpdated(data) {
      if (data && data.id) {
        const index = this.problemList.findIndex((problem) => String(problem.id) === String(data.id));
        const prev = index !== -1 ? this.problemList[index] : null;
        const merged = this.mergeProblemView(prev, data);
        this.playProblemUpdateSound(merged);
        if (index !== -1) {
          this.$set(this.problemList, index, merged);
          if (String(this.activeProblemId) === String(data.id)) {
            this.currentProblem = merged;
            this.$nextTick(() => {
              this.scrollToBottom();
            });
          }
        } else {
          this.problemList.push(merged);
        }
      } else {
        this.loadProblemList();
      }
    },

    mergeProblemView(prev, data) {
      const next = { ...data };
      if (!next.route && prev && prev.route) {
        next.route = prev.route;
      }
      if (!next.order && prev && prev.order) {
        next.order = prev.order;
      }
      if (!next.routeId && prev && prev.routeId) {
        next.routeId = prev.routeId;
      }
      return next;
    },

    handleTabChange(tab) {
      const problemId = tab.name;
      this.activeProblemId = problemId;
      const problem = this.problemList.find((p) => p.id === problemId);
      this.currentProblem = problem;
      // 如果该问题有未读信息，更新已读状态
      if (problem && problem.hasNewInfoToRead) {
        updateKfInfoReadStatus(problemId).then((res) => {
          // 更新问题列表中的对应项
          const index = this.problemList.findIndex((p) => p.id === problemId);
          if (index !== -1) {
            this.$set(this.problemList, index, res.data || {});
          }
          // 更新当前问题
          this.currentProblem = res.data || {};
        });
      }

      this.$nextTick(() => {
        this.scrollToBottom();
      });
    },
    // 加载问题列表
    loadProblemList() {
      getKfNeedFocusProblemList().then((res) => {
        this.problemList = res.data || [];
        if (this.problemList.length === 0) {
          this.activeProblemId = "";
          this.currentProblem = null;
          return;
        }

        // 重新打开 drawer 时，尽量保持上一次选中的 tab
        const prevId = this.activeProblemId;
        const hit = prevId && this.problemList.find((p) => p.id === prevId);
        const nextId = hit ? prevId : this.problemList[0].id;

        this.activeProblemId = nextId;
        this.currentProblem =
          this.problemList.find((p) => p.id === nextId) || this.problemList[0];

        this.$nextTick(() => {
          this.scrollToBottom();
        });
      });
    },

    // 加载问题详情
    loadProblemDetail(problemId) {
      getOrderProblem(problemId).then((res) => {
        this.currentProblem = res.data || {};
        // 滚动到底部
        this.$nextTick(() => {
          this.scrollToBottom();
        });
      });
    },

    // 处理操作成功回调
    handleActionSuccess(data) {
      this.updateCurrentProblem(data);
    },

    handleCloseProblem(problem) {
      if (!problem || !problem.id) return;
      const problemId = problem.id;
      this.$confirm("确认关闭该问题？关闭后将不再出现在待处理列表中。", "提示", {
        type: "warning",
        confirmButtonText: "确定",
        cancelButtonText: "取消"
      })
        .then(() => closeProblem(problemId))
        .then(() => {
          this.$message.success("已关闭");
          this.loadProblemList();
        })
        .catch(() => { });
    },

    updateCurrentProblem(info) {
      this.currentProblem = info;
      const index = this.problemList.findIndex((problem) => problem.id === info.id);
      if (index !== -1) {
        this.$set(this.problemList, index, info);
      }
      // 滚动到底部
      this.$nextTick(() => {
        this.scrollToBottom();
      });
    },

    // 滚动到底部
    scrollToBottom() {
      const getMessageListEl = () => {
        const ref = Array.isArray(this.$refs.messageList)
          ? this.$refs.messageList[0]
          : this.$refs.messageList;
        return ref || document.querySelector(".order-problem-drawer .message-list");
      };

      const tryScroll = (retryCount = 0) => {
        const el = getMessageListEl();
        if (el && el.scrollHeight > 0) {
          el.scrollTop = el.scrollHeight;
        } else if (retryCount < 10) {
          setTimeout(() => tryScroll(retryCount + 1), 50);
        }
      };

      this.$nextTick(() => tryScroll());
    },

    // 获取问题标签
    getProblemLabel(problem) {
      if (problem.problemDesc) {
        const desc =
          problem.problemDesc.length > 10
            ? problem.problemDesc.substring(0, 10) + "..."
            : problem.problemDesc;
        return desc;
      }
      return `问题 #${problem.id ? problem.id.substring(0, 8) : ""}`;
    },

    // 启动定时刷新
    startRefreshTimer() {
      this.stopRefreshTimer();
      this.refreshTimer = setInterval(() => {
        if (this.visible && this.activeProblemId) {
          this.loadProblemDetail(this.activeProblemId);
          // 也刷新问题列表
          this.loadProblemList();
        }
      }, 10000); // 每10秒刷新一次
    },

    // 停止定时刷新
    stopRefreshTimer() {
      if (this.refreshTimer) {
        clearInterval(this.refreshTimer);
        this.refreshTimer = null;
      }
    },

    // SUBMIT 播 submit_problem.wav，APPEND 播 add_info.wav，关闭或中间态不播
    playProblemUpdateSound(data) {
      if (!data || data.status === "CLOSED" || !data.notifyScene) {
        return;
      }
      if (data.notifyScene === "SUBMIT") {
        this.playProblemSound("submit");
      } else if (data.notifyScene === "APPEND") {
        this.playProblemSound("add");
      }
    },

    playProblemSound(kind) {
      if (LocalStorage.get("silent")) {
        return;
      }
      const submitAudio = this.$refs.submitProblemAudio;
      const addAudio = this.$refs.addInfoAudio;
      const audio = kind === "submit" ? submitAudio : addAudio;
      const other = kind === "submit" ? addAudio : submitAudio;
      if (!audio) {
        return;
      }
      if (other && !other.paused) {
        other.pause();
      }
      try {
        audio.currentTime = 0;
      } catch (e) {
        // 音频尚未可寻址时忽略
      }
      const playResult = audio.play && audio.play();
      if (playResult && typeof playResult.catch === "function") {
        playResult.catch(() => { });
      }
    },

    // 判断是否为图片
    isImage(url) {
      if (!url) return false;
      return FileUtil.isImage(url);
    },

    // 判断是否为视频
    isVideo(url) {
      if (!url) return false;
      return FileUtil.isVedio(url);
    },

    showRoutePlan(routeId) {
      this.$bus.$emit(SHOW_ROUTE_PLAN, { id: routeId }, false);
    },

    async go2MonitorPage(item) {
      if (!item || !item.driverId) {
        return;
      }
      const driverResp = await getDriverInfo({ id: item.driverId });
      const { videoDeviceId } = driverResp.data || {};
      const { href } = Router.resolve({
        path: "/video/monitor",
        query: { deviceNo: videoDeviceId, driverId: item.driverId }
      });
      window.open(href, "_blank");
    },

    // 获取图片列表（用于预览）
    getImageList(photos) {
      if (!photos || !Array.isArray(photos)) return [];
      return photos.filter((url) => this.isImage(url));
    }
  }
};
</script>

<style scoped lang="less">
.order-problem-drawer {
  /deep/ .el-drawer__body {
    padding: 0;
    display: flex;
    flex-direction: column;
    height: 100%;
  }
}

.content-wrapper {
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;

  /deep/ .el-tabs {
    display: flex;
    flex-direction: column;

    .el-tabs__header {
      margin: 0;
      border-bottom: 1px solid #e4e7ed;
    }

    .el-tabs__content {
      flex: 1;
      overflow: hidden;
      padding: 0;

      .el-tab-pane {
        min-height: 0;
        display: flex;
        flex-direction: column;
      }
    }
  }
}

.problem-content {
  height: calc(100vh - 50px);
  display: flex;
  flex-direction: column;
  padding: 20px;
  overflow: hidden;
  min-height: 0;
  box-sizing: border-box;
}

.problem-actions {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 10px;
  flex-shrink: 0;
}

.problem-route-actions {
  display: flex;
  align-items: center;
  gap: 8px;

  .el-button + .el-button {
    margin-left: 0;
  }
}

.order-route-status {
  margin-left: 12px;
  color: #e6a23c;
  white-space: nowrap;
}

.problem-info {
  margin-bottom: 0;
  padding: 0;
  background-color: #f5f7fa;
  border-radius: 4px;
  flex-shrink: 0;

  /deep/ .el-descriptions {
    background-color: #fff;
    padding-bottom: 20px;
    border-radius: 4px;
  }
}

.message-list {
  flex: 1;
  overflow-y: auto;
  overflow-x: hidden;
  padding: 10px;
  background-color: #f5f7fa;
  border-radius: 4px;
  min-height: 0;
  box-sizing: border-box;
}

.message-item {
  margin-bottom: 20px;
  display: flex;

  &.message-left {
    justify-content: flex-start;

    .message-bubble {
      background-color: #e4e7ed;
      color: #303133;
      border-radius: 12px 12px 12px 4px;
      border: 1px solid #dcdfe6;
    }
  }

  &.message-right {
    justify-content: flex-end;

    .message-bubble {
      background-color: #fff;
      color: #303133;
      border-radius: 12px 12px 4px 12px;
      border: 1px solid #e4e7ed;
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.12);
    }
  }
}

.message-bubble {
  max-width: 70%;
  min-width: 200px;
  padding: 12px 16px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.08);

  .message-content {
    word-wrap: break-word;
    white-space: pre-wrap;
    line-height: 1.5;
    margin-bottom: 6px;
  }

  .message-time {
    font-size: 12px;
    color: #909399;
    margin-top: 6px;

    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  &.bubble-kf {
    .message-time {
      color: #909399;
    }

    .to-handle-text {
      color: #e6a23c;
      cursor: pointer;
    }

    .to-handle-text2 {
      color: #409eff;
    }
  }

  &.bubble-driver {
    .message-time {
      color: #909399;
    }
  }
}

.message-choices {
  margin-top: 12px;
  padding-top: 12px;
  border-top: 1px solid rgba(0, 0, 0, 0.1);
}

.message-right .message-choices {
  border-top-color: rgba(0, 0, 0, 0.1);
}

.message-left .message-choices {
  border-top-color: rgba(0, 0, 0, 0.1);
}

.choice-item {
  padding: 8px 12px;
  margin-top: 8px;
  background-color: #f0f2f5;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.3s;
  display: flex;
  align-items: center;

  &:hover {
    background-color: #e4e7ed;
  }

  i {
    margin-right: 8px;
    color: #409eff;
  }

  span {
    flex: 1;
  }
}

.message-right .choice-item {
  background-color: #f0f2f5;
}

.message-left .choice-item {
  background-color: #e4e7ed;
  color: #303133;

  i {
    color: #409eff;
  }

  &:hover {
    background-color: #d3d4d6;
  }
}

.message-photos {
  margin-top: 12px;
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.media-item {
  display: inline-block;
}

.message-photo {
  width: 100px;
  height: 100px;
  border-radius: 4px;
  cursor: pointer;
  object-fit: cover;
}

.message-media {
  /deep/ .file-preview {
    .image-preview {
      max-width: 100px;
      max-height: 100px;
    }

    .video-preview {
      width: 200px;
      max-width: 100%;
    }

    .audio-preview {
      min-width: 200px;
      max-width: 100%;
    }
  }
}

.empty-message {
  text-align: center;
  padding: 40px 0;
  color: #909399;
  font-size: 14px;
}

.problem-badge {
  line-height: 24px;
}

.new-info {
  animation: flash-text 1s ease-in-out infinite;
}

@keyframes flash-text {

  0%,
  100% {
    opacity: 1;
    color: #ff4d4f;
  }

  50% {
    opacity: 0.3;
    color: #ff7875;
  }
}
</style>
